module.exports = __webpack_public_path__ + "img/Without_the_word.cd83095c.png";